import { render, staticRenderFns } from "./JBProposalHomeRisk.vue?vue&type=template&id=27ca9f35"
import script from "./JBProposalHomeRisk.vue?vue&type=script&lang=js"
export * from "./JBProposalHomeRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports